/* نوع تگ از پنل می‌آید (`fields.title.type`). عمداً h1 تولید نمی‌شود: عنوان هر
   صفحه در خود کامپوننت آن صفحه رندر می‌شود، پس اگر یک ویجت هم h1 بدهد صفحه
   بیش از یک h1 پیدا می‌کند. h1 انتخاب‌شده در پنل به h2 تنزل می‌یابد.
   h3 هم به h2 می‌رسد: ویجت‌ها مستقیم زیر h1 صفحه می‌نشینند و بین آن‌ها h2 ای نیست، پس h3 یک
   سطح را می‌پرد و Lighthouse (heading-order) آن را خطا می‌گیرد. قسمت‌هایی که واقعاً زیرمجموعه‌ی یک
   h2 هستند با `exact` همان سطح پنل را نگه می‌دارند. ستون‌های فوتر `exact` ندارند: در صفحه‌ای که
   فقط h1 دارد (مثل جستجوی مجله) فوتر مستقیم بعد از h1 می‌آید و h3 آن سطح را می‌پرد. */
const Title = ({ type, children, className, exact = false }) => {
  if (type === "h1" || type === "h2" || (type === "h3" && !exact)) return <h2 className={className}>{children}</h2>;
  else if (type === "h3") return <h3 className={className}>{children}</h3>;
  else if (type === "h4") return <h4 className={className}>{children}</h4>;
  else if (type === "h5") return <h5 className={className}>{children}</h5>;
  else if (type === "h6") return <h6 className={className}>{children}</h6>;
  else if (type === "span")
    return <span className={className}>{children}</span>;
};

export default Title;
